import React from 'react';

import { useConfiguration } from '../../../hooks/Configuration';
import { EMessageDirection, IMessageComplete } from '../../../hooks/Messages';
import Packer from './Packer';

export interface IMessageWrapperProps {
    direction: IMessageComplete['direction'],
    children: any
    info?: any
}

function MessageWrapper({ direction, children, info }: IMessageWrapperProps) {
    const configuration = useConfiguration();
    const incomming = direction === EMessageDirection.Incomming;
    const className = [
        'stx-chat-message-wrapper',
        incomming ? 'stx-incomming-chat-message' : 'stx-outcomming-chat-message'
    ];

    return (
        <div className={className.join(' ')}>
            <div
                className='stx-chat-message'
                style={incomming ?
                    {
                        backgroundColor: configuration?.styles.messageInBgColor,
                        color: configuration?.styles.messageInTextColor
                    } :
                    {
                        backgroundColor: configuration?.styles.messageOutBgColor,
                        color: configuration?.styles.messageOutTextColor
                    }}>
                {incomming ? <Packer>{children}</Packer> : children}
            </div>
            {
                !!info &&
                <div className='stx-chat-message-info'>{info}</div>
            }
        </div>
    );
}

export default MessageWrapper;
